import axios from 'axios'
import store from '@/store'
import {getToken} from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import {tansParams} from "@/utils/jiutang";
import {Toast} from "vant";
// import cache from '@/plugins/cache'

//本地环境
// export let baseUrl = "http://grc.jtkji.cn/h5-api";
// export let imgUrl = "http://10.0.0.18:8230";
//测试环境
// export let baseUrl = "http://10.0.0.18:8231";
// export let imgUrl = "http://10.0.0.18:8230";
//正式环境-金太阳
export let baseUrl = "http://volunteer.jtkji.cn/h5-api";
export let imgUrl = "http://volunteer.jtkji.cn/prod-api";
// 微信统一授权地址
export let wxAuthUrl = "http://u.jtkji.cn/wechat/jtauth?state={state}&reqUrl={reqUrl}";

//账号密码加密公钥:不以明文存放,而是按“逐字符编码 ^ 掩码 → 十六进制”混淆,
//运行时还原后再导出,避免完整公钥字符串直接出现在打包产物中供人直接阅读。
//注意:RSA 公钥本身是公开的、不构成机密;此处仅为降低静态可读性/扫描识别度。
//如需更换公钥:对新的公钥字符串逐字符做 (charCode ^ 0x2a) 并转十六进制填入下方即可。
const PUBLIC_KEY_MASK = 0x2a
const PUBLIC_KEY_XOR_HEX = '67636d4c676b1a6d69795b6d796348196e7b6f686b7b7f6b6b1e6d646b6e6968437b61684d7b6941685067137c1d4c6949195f5f6c441a401f494f467d535a5e675e12507f185b4b66581c5f196b41051b665a5c674f7a691e194553701c7c197b4f7c5d4c444263796d1a401964056553527f6c6c014572191a53621f1366736b4c134665181b41785c4668194761676e497845615e1205507f191918406f1f4c6343625a6278125d625d5b72635e78724f1973624e5a6e604d644c1e73636953017d136d5b45736d6f7e444d6c7e6e6f5d636e6b7b6b68'

function restorePublicKey() {
    let text = ''
    const hex = PUBLIC_KEY_XOR_HEX
    for (let i = 0; i < hex.length; i += 2) {
        text += String.fromCharCode(parseInt(hex.substr(i, 2), 16) ^ PUBLIC_KEY_MASK)
    }
    return text
}

export let publicKey = restorePublicKey()

// 是否显示重新登录
export let isRelogin = {show: false}

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: baseUrl, // 超时
    timeout: 60000
})

// request拦截器
service.interceptors.request.use(config => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
    if (getToken() && !isToken) {
        config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
        let url = config.url + '?' + tansParams(config.params)
        url = url.slice(0, -1)
        config.params = {}
        config.url = url
    }
    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    // 二进制数据则直接返回
    if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
        return res.data
    }
    if (code === 401) {
        if (!isRelogin.show) {
            isRelogin.show = true
            // Toast('登录状态已过期,请重新登录')
            setTimeout(() => {
                isRelogin.show = false
                Toast.clear()
                store.dispatch('LogOut').then(() => {
                    // location.href = '/h5/mine/sign'
                    // location.href = baseUrl + '/h5/wechat/auth'
                    let url = window.location.href;
                    let hrefUrl = wxAuthUrl.replace("{state}", url)
                        .replace("{reqUrl}", baseUrl + "/h5/wechat/getUserInfo")
                    console.log('跳转=>' + hrefUrl)
                    location.href = hrefUrl
                })
            }, 1000);
        }
        return Promise.reject('登录已过期，请重新登录。')
    } else if (code === 500) {
        Toast(msg)
        return Promise.reject(new Error(msg))
    } else if (code !== 200) {
        Toast(msg)
        return Promise.reject('error')
    } else {
        return res.data
    }
}, error => {
    console.log('err' + error)
    let {message} = error
    if (message == 'Network Error') {
        message = '后端接口连接异常'
    } else if (message.includes('timeout')) {
        message = '系统接口请求超时'
    } else if (message.includes('Request failed with status code')) {
        message = '系统接口' + message.substr(message.length - 3) + '异常'
    }
    Toast(message)
    return Promise.reject(error)
})


export default service
